<template>
<div>
<div v-if="finalModel.applications.length==0">{{$vuetify.lang.t('$vuetify.cui-org-no-applications')}}</div>
<div v-else-if="finalModel.applications.length > 0">
  <div style="float:right;margin-bottom:40px" class="cui-link">
    {{$vuetify.lang.t('$vuetify.cui-selections')}}<span class="cui-badge" id="popover-selectedApps">{{this.selectedAppsCount}}</span>
  </div>
  <b-popover v-if="selectedApps !== undefined && selectedApps.includes(true)" target="popover-selectedApps" triggers="hover focus" placement="bottom">
    <template v-slot:title>
        <div class="cui-badge">{{selectedAppsCount}}</div>
        <span >{{$vuetify.lang.t('$vuetify.cui-selected-apps')}}</span>
    </template>
       <div  class="cui-popover__row cui-popover--row__flex"  v-for="(selected,indexApp) in selectedApps" :key="indexApp">
                  <span  v-if="selected === true">{{finalModel.applications[indexApp].name[0].text}}</span>
       </div>
        <!-- <span class="cui-link">Got it!</span> -->
  </b-popover>
<div  v-for="(app,index) in finalModel.applications" :key="app[index]">
    <v-checkbox v-model="selectedApps[index]" @change="updateAppsCount(index)" :label="app.name[0].text" checked="false"></v-checkbox>
    <hr/>
</div>
</div>
<div class="cui-wizard__controls" style="margin:20px 0 10px">{{$vuetify.lang.t('$vuetify.cui-application-select-info')}}</div>
</div>
</template>
<script>
export default {
  data () {
    return {
      selectedApps: [],
      selectedAppsCount: 0
    }
  },
  validations: {
    form: []
  },
  props: ['finalModel'],
  methods: {
    validate () {
      this.$v.form.$touch()
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },
    updateAppsCount (index) {
      if (this.selectedApps[index]) {
        this.selectedAppsCount++
      } else if (!this.selectedApps[index] && this.selectedAppsCount > 0) {
        this.selectedAppsCount--
      } else {
        this.selectedAppsCount = 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/registration/applications.vue